module.exports = __webpack_public_path__ + "img/flag_en_medium.4fc5806e.png";